export default "__VITE_ASSET__KSYUGKgD__"